const locale = {
  dashboard: 'Tableau de bord',
  home_dashboard: 'Accueil',
  dashboard_news: 'Actualités',
  dashboard_slides: 'Bannières',
  dashboard_notifications: 'Notifications',
  dashboard_account: 'Mon compte',
  dashboard_team: 'Mon équipe',
  dashboard_mini_site: 'Mini-site',
  my_codes: 'Mes codes',
  dashboard_loyalty_campaign: 'Campagne de fidelité',
  product_order: 'Commande produits',
  digital_pub: 'Publicité digitale',
  world_house: "Maisons du monde",
  vistaprint: "Vistaprint",
  training: 'Formation',
  dashboard_content_library: 'Bibliothèque de contenus',
  hairdressers_network: 'Réseau de salon',
  hairdressers: 'Salons',
  hairdressers_list: 'Liste des salons',
  hairdresser_add: 'Ajouter un salon',
  link_hairdresser_supervisor: 'Associer un salon',
  services: 'Services',
  services_list: 'Liste des services',
  services_add: 'Ajouter un service',
  services_link: 'Associer un service',
  national_operations: 'Op. nationales',
  national_operations_list: 'Liste des op. nationales',
  national_operations_add: 'Ajouter une op. nationale',
  national_operations_participate: 'Associer une op. nationale',
  legals: 'Mentions légales',
  legals_list: 'Liste des mentions légales',
  legals_add: 'Ajouter une mention légale',
  legals_participate: 'Associer une mention légale',
  prices: 'Prestations & tarifs',
  prices_list: 'Liste des prestations & tarifs',
  jobs: "Offres d'emploi",
  jobs_list: "Liste des offres d'emploi",
  jobs_add: "Ajouter une offre d'emploi",
  customer_relationship: 'Relation client',
  contacts: 'Contacts',
  contacts_list: 'Liste des contacts',
  contacts_import: 'Importer des contacts',
  origin_code_list: 'Liste des codes origines',
  origin_code_add: 'Ajouter un code origine',
  feedbacks: 'Avis clients',
  feedbackslanguage: 'Langue',
  feedbacks_list: 'Liste des avis clients',
  feedbacks_response_model: 'Modèle de réponse',
  feedbacks_receiver: 'Destinataires des avis',
  access: 'Accès',
  collaborators: 'Liste des collaborateurs',
  collaborators_add: 'Ajouter un collaborateur',
  users_and_groups: 'Utilisateurs et groupes',
  users_list: 'Liste des utilisateurs',
  users_add: 'Ajouter un utilisateur',
  groups_list: 'Liste des groupes',
  groups_add: 'Ajouter un groupe',
  resources: 'Ressources',
  press: 'Espace presse',
  press_admin: 'Administration presse',
  documentation: 'Documentation',
  documentation_admin: 'Administration documentation',
  intranet_doc: 'Espace documentaire',
  intranet_doc_admin: 'Admin Documents v2',
  intranet_doc_v2: 'Documents v2',
  mass_administration: 'Gestion en masse',
  minisite: 'Minisites',
  minisiteList: 'Suivi des mises à jour',
  minisiteMessageList: "Liste des messages d'accueil",
  minisiteTagList: 'Liste des balises SEO',
  minisiteMassiveImport: 'Administration multi salons',
  mass_administration_price_list: 'Prestations & Tarifs',
  mass_administration_businessHours_list: 'Horaires',
  mass_administration_message_list: "Messages d'accueil",
  mass_administration_tag_list: 'Balises SEO',
  mass_administration_picture_list: 'Visuel salon',
  access_to: 'Accès à',
  payment_x3: 'Paiement en 3x',
  terms_nav: 'Termes & Conditions',
  TOU: 'CGU',
  privacy_policy: 'Politique de confidentialité',
  cookies_policy: 'Politique de gestion des cookies',
  faq: 'Questions fréquentes'
};

export default locale;
